import firebase from 'firebase/compat/app'
import { getApp } from 'firebase/app'
import { getConfig } from './getConfig'
import { getExportedEnv } from './getExportedEnv'
import { getProcessEnv } from './getProcessEnv'

const env = (() => {
  const processenv = getProcessEnv()
  const config = getConfig()
  const exported = getExportedEnv()
  return { ...processenv, ...config, ...exported } as any
})()

const getFirebaseConfig = () => ({
  apiKey: env.EXPO_PUBLIC_FIREBASE_API_KEY,
  authDomain: env.EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: env.EXPO_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: env.EXPO_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.EXPO_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.EXPO_PUBLIC_FIREBASE_APP_ID,
  measurementId: env.EXPO_PUBLIC_FIREBASE_MEASUREMENT_ID,
  databaseURL: env.EXPO_PUBLIC_FIREBASE_DATABASE_URL,
})

// Use compat initializeApp so both the compat and modular registries are populated.
// The compat app() function reads from its own apps map (not the modular _apps map),
// so modular-only initializeApp would make firebase.app() throw "no-app".
export const app = () => {
  if (!firebase.apps.find(a => a.name === '[DEFAULT]')) {
    firebase.initializeApp(getFirebaseConfig())
  }
  return getApp()
}
